<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <ion-card color="primary">
                    <ion-card-header>
                        <ion-card-subtitle class="text-center u-mb2">
                            <ion-avatar class="big-avatar">
                                <img :src="profile.avatar" v-if="profile.avatar">
                                <img src="../../assets/ghost-avatar-white.png" class="dark-img" v-else>
                            </ion-avatar>
                        </ion-card-subtitle>
                        <ion-card-title>
                            {{profile.name}}
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div v-html="nl2br(profile.profile)"></div>
                        <div v-if="profile.id != $root.user.id">
                            <ion-button shape="round" expand="full" v-on:click="block()" style='margin-top: 50px;'>Block {{profile.name}}</ion-button>
                        </div>
                    </ion-card-content>
                </ion-card>
            </div>
        </div>
        <return-home />
    </div>
</template>

<script>

import ReturnHome from '@/components/ReturnHome.vue'
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {formatting} from '@/mixins/formatting';
import {alerts} from '@/mixins/alerts';

export default {
    name: 'profile',
    mixins : [auth, userdetails, formatting, alerts],
    components : {
        ReturnHome
    },
    data : function () {
        return {
            profile : {}
        }
    },
    computed : {
        //
    },
    mounted : function () {
        this.getUser();
    },
    methods : {
        getUser : function () {
            let self = this;
            this.axios.get(this.api + 'users/profile/' + this.$route.params.id)
                .then(response => {
                    self.profile = response.data;
                })
                .catch(error => {
                    console.error('Error getting user', error);
                    self.back();
                });
        },
        back : function () {
            this.$router.push({name : 'home'});
        },
        block : function () {
            let self = this,
                msg  = `Please confirm that you want to block ${this.profile.name}.
                You will no longer receive messages from them, and all existing messages
                will be removed.  You cannot undo this action.`;
            this.showConfirm('Are you sure?', msg, function () {
                self.confirmBlock();
            })
        },
        confirmBlock : function () {
            let self = this;
            this.axios.post(this.api + 'users/' + this.$route.params.id + '/block')
                .then(response => {
                    let msg = `You have blocked  ${this.profile.name} and you will no longer receive messages from them`;
                    self.showSuccess (msg, function () {
                        self.$router.replace({name : 'home'});
                    });
                })
                .catch(error => {
                    console.error('Error blocking user', error);
                    self.showError(`There was a problem blocking ${this.profile.name}. You might need to try again.`);
                });
        }
    }
}
</script>